import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';
import { COMPANY_CONFIG, COMPANY_CONTACT, SERVICE_AREAS, SOCIAL_MEDIA } from '../config/company';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-text">BAMA</span>
              <span className="logo-subtext">BILLBOARDS</span>
            </div>
            <p className="footer-description">
              {COMPANY_CONFIG.description}
            </p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/inventory">Inventory</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhone />
                <span>{COMPANY_CONTACT.phone}</span>
              </div>
              <div className="contact-item">
                <FaEnvelope />
                <span>{COMPANY_CONTACT.email}</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span>{COMPANY_CONTACT.serviceArea}</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3>Service Areas</h3>
            <ul className="service-areas">
              {SERVICE_AREAS.map((area, index) => (
                <li key={index}>{area}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Bama Billboards. All rights reserved.</p>
            <div className="social-links">
              <a href={SOCIAL_MEDIA.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href={SOCIAL_MEDIA.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href={SOCIAL_MEDIA.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 